import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Ajustes } from './Ajustes';
import { Banco } from './Banco';
import { Configuracao } from './Configuracao';
import { Espelho } from './Espelho';
import { Fechamentos } from './Fechamentos';
import { Fiscal } from './Fiscal';
import { i18n } from './i18n';
import { Marcacoes } from './Marcacoes';
import { Marcar } from './Marcar';

/** Registro de ponto (lote 1, núcleo), no menu Pessoas. Ficha: demandas/entrada/2026-10-19_malgo_MOD_ponto.md. */
const modulo: ModuloWeb = {
  slug: 'ponto',
  menu: 'pessoas',
  ordem: 35,
  abas: [
    { chave: 'marcar', permissao: 'ponto.criar', componente: Marcar },
    { chave: 'marcacoes', permissao: 'ponto.ver', componente: Marcacoes },
    { chave: 'espelho', permissao: 'ponto.ver', componente: Espelho },
    { chave: 'ajustes', permissao: 'ponto.ver', componente: Ajustes },
    { chave: 'banco', permissao: 'ponto.ver', componente: Banco },
    { chave: 'fechamentos', permissao: 'ponto.ver_todos', componente: Fechamentos },
    // Lote 4: ponto oficial (REP-P) e arquivos fiscais (AFD e AEJ).
    { chave: 'fiscal', permissao: 'ponto.ver_todos', componente: Fiscal },
    { chave: 'configuracao', permissao: 'ponto.ver', componente: Configuracao },
  ],
  i18n,
};

export default modulo;
